import { render, staticRenderFns } from "./ManageDetail.vue?vue&type=template&id=3a827b28&scoped=true&"
import script from "./ManageDetail.vue?vue&type=script&lang=js&"
export * from "./ManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./ManageDetail.vue?vue&type=style&index=0&id=3a827b28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a827b28",
  null
  
)

export default component.exports